export enum ETipoOperacaoCfop {
    NaoEspecificada = 0,
    EntradaDentroEstado = 1,
    EntradaForaEstado = 2,
    EntradaImportacao = 3,
    SaidaDentroEstado = 4,
    SaidaForaEstado = 5,
    SaidaExportacao = 6,
}
